import {useRouter} from 'next/router';
import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';

import {SEARCH_TYPE} from '@/src/app/constants/search';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Text} from '@/src/ui';

import css from '../styles/TotalResultsCount.module.css';

const getTotalResultsTextId = (totalAmount, activeSearchType, searchQuery) => {
  let resultTextId;

  switch (activeSearchType) {
    case SEARCH_TYPE.COURSES: {
      resultTextId =
        totalAmount === 1
          ? 'search.one-course-total'
          : 'search.many-courses-total';
      break;
    }

    case SEARCH_TYPE.POSTS: {
      resultTextId =
        totalAmount === 1 ? 'search.one-post' : 'search.many-posts-total';
      break;
    }

    case SEARCH_TYPE.CLINICS: {
      resultTextId =
        totalAmount === 1
          ? 'search.one-clinic-total'
          : 'search.many-clinic-total';
      break;
    }

    default:
      resultTextId =
        totalAmount === 1 ? 'search.one-user-total' : 'search.many-users-total';
  }

  if (!searchQuery) {
    resultTextId = resultTextId + '-without-query';
  }

  return resultTextId;
};

const TotalResultsCount = ({totalAmount, activeSearchType, searchQuery}) => {
  const {events} = useRouter();
  const [isLoadingNePage, setLoadingNewPage] = useState(false);

  useEffect(() => {
    events.on('routeChangeStart', () => {
      setLoadingNewPage(true);
    });

    return () => {
      events.off('routeChangeStart', () => {
        setLoadingNewPage(false);
      });
    };
  }, []);

  const textId = getTotalResultsTextId(
    totalAmount,
    activeSearchType,
    searchQuery
  );

  return (
    <div className={css.widget}>
      <Text
        fontSize={Text.FONT_SIZE.SIZE_24}
        fontWeight={Text.FONT_WEIGHT.BOLD}
        fontFamily={Text.FONT_FAMILY.POPPINS}
      >
        {isLoadingNePage ? (
          <div
            dangerouslySetInnerHTML={{
              __html: '&nbsp;',
            }}
          />
        ) : (
          <TextLocal id={textId} params={{totalAmount, searchQuery}} />
        )}
      </Text>
    </div>
  );
};

TotalResultsCount.propTypes = {
  totalAmount: PropTypes.number,
  activeSearchType: PropTypes.string,
  searchQuery: PropTypes.string,
};

export default TotalResultsCount;
